function safeJSONParse (text, fallback = {}) {
    try {
        return JSON.parse(text);
    }
    catch (err) {
        return fallback;
    }
}

export { safeJSONParse as default };
//# sourceMappingURL=safeJSONParse.js.map
